import React from "react";
import './Body3.css';
import  { useState } from 'react';
import picture15 from './source/picture15.png'
import picture16 from './source/picture16.png'
import picture17 from './source/picture17.png'
import picture18 from './source/picture18.png'
import picture19 from './source/picture19.png'
import picture20 from './source/picture20.png'
import picture21 from './source/picture21.png'
import picture22 from './source/picture22.png'
import picture23 from './source/picture23.png'
import picture24 from './source/picture24.png'
import picture25 from './source/picture25.png'

import picture27 from './source/picture27.png'
import picture28 from './source/picture28.png'
import picture29 from './source/picture29.png'
import picture30 from './source/picture30.png'
import picture31 from './source/picture31.png'
import picture32 from './source/picture32.png'
import picture33 from './source/picture33.png'
import picture34 from './source/picture34.png'





function Body3() {

const [imageSrc, setImageSrc] = useState({
image1: picture15,
image2: picture16,
image3: picture17,
image4: picture18,
image5: picture19,
image6: picture20,
image7: picture21,
image8: picture22

});


const handleClick1 = () => {

setImageSrc({
image1: picture15,
image2: picture16,
image3: picture17,
image4: picture18,
image5: picture19,
image6: picture20,
image7: picture21,
image8: picture22 

});
};

const handleClick2 = () => {

setImageSrc({
image1: picture31,
image2: picture32,
image3: picture33,
image4: picture34,
image5: picture27,
image6: picture28,
image7: picture29,
image8: picture30  

});
};

const handleClick3 = () => {

setImageSrc({
image1: picture23,
image2: picture23,
image3: picture23,
image4: picture23,
image5: picture23,
image6: picture23,
image7: picture23,
image8: picture23   

});
};

const handleClick4 = () => {

setImageSrc({
image1: picture24,
image2: picture25,
image3: picture23,
image4: picture23,
image5: picture23,
image6: picture23,
image7: picture23,
image8: picture23   

});
};

  return (
  <div className="body34">
    <div className="body3">
      <div className="body3-box1">
        <div className="body3-box2">
          <div className="body3-box3">
          Projekty a realizace
          </div>
          <div className="body3-box4">
            <div className="body3-box10"></div>
          </div>
          <div className="body3-box5">
            <div className="body3-box6" onClick={handleClick1}>Sádrokarton</div>
            <div className="body3-box7" onClick={handleClick2}>Půdní vestavby</div>
            <div className="body3-box8" onClick={handleClick3}>Dřevěné stropy</div>
            <div className="body3-box9" onClick={handleClick4}>Podlahářské práce</div>
          </div>
        </div>
      </div>
    </div> 

    <div className="body3-box11">
      <img className="body3-box11-picture15" src={imageSrc.image1} alt="picture15"/>
      <img className="body3-box11-picture16" src={imageSrc.image2} alt="picture16"/>
      <img className="body3-box11-picture17" src={imageSrc.image3} alt="picture17"/>
      <img className="body3-box11-picture18" src={imageSrc.image4} alt="picture18"/>
      <img className="body3-box11-picture19" src={imageSrc.image5} alt="picture19"/>
      <img className="body3-box11-picture20" src={imageSrc.image6} alt="picture20"/>
      <img className="body3-box11-picture21" src={imageSrc.image7} alt="picture21"/>
      <img className="body3-box11-picture22" src={imageSrc.image8} alt="picture22"/>
    </div>

  </div>
  );
}

export default Body3;
